import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RenderSvg from "../../components/RenderSvg";
import React, { useContext, useEffect } from "react";
import JourneyConfig from "../../context/JourneyConfig";
import Footer from "../../components/Footer";
import { ArrowPathIcon } from "@heroicons/react/16/solid";
import Head from "../Head";
function FaceCheckError({ stepperFunc, onNextStep, color, errorHandlerTexts, config }) {
  const { journey, getJourney } = useContext(JourneyConfig);
  const handleRefresh = async () => {
    sessionStorage.removeItem("error");
    if (!journey) {
      await getJourney(sessionStorage.getItem("jId"));
    }
    stepperFunc(
      sessionStorage.getItem("currentStep")
        ? parseInt(sessionStorage.getItem("currentStep"))
        : 10
    );
  };
  useEffect(() => {
      return () => {
        sessionStorage.removeItem("error");
        sessionStorage.removeItem("errorCategory");
        sessionStorage.removeItem("errorReason");
      };
    }, []);
  return (
    <>
       <Head
        style={{ zIndex: "100" }}
        onNextStep={onNextStep}
        showLanguages={false}
        showMobileFlow={false}
        showCountry={false}
        showHelp={false}
        stepperFunc={stepperFunc}
      />

      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg
              config={config}
              id={"unable_to_process"}
              svgType={"unable_to_process"}
              className="md:w-[300px] md:h-[280px] w-[350px] h-[350px]"
              style={{ marginTop: "3rem" }}
            />
          </div>

          <div
            className="right-section md:items-start items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 24,
              fontFamily: "Inter, sans-serif",
            }}
          >
            <div
              className="flex flex-col items-start justify-center w-full"
              style={{ height:  "100%" }}
            >
              
              
                <div className="flex flex-col items-start w-full mt-14">
                  <div
                    className="w-[44px] h-[44px] flex items-center justify-center rounded-full mb-3"
                    style={{
                      backgroundColor: "color-mix(in srgb, " + color + " 10%, white)",
                      color: color,
                    }}
                  >
                    <ErrorOutlineIcon aria-hidden={false} aria-label="Error icon" style={{ fontSize: 24 }} />
                  </div>
                  
                  <div
                    className="text-[18px] md:text-[26px] font-semibold text-center md:text-left mb-2"
                    style={{ color: color  }}
                  >
                    {errorHandlerTexts.heading}
                  </div>
                  
                </div>
            </div>

            {/* Try again button */}
            <div className="w-full">
              <div className="flex flex-col w-full justify-center items-center">
                <button
                  className="flex flex-row text-[14px] items-center justify-center gap-4 w-full text-white py-4 px-4 rounded mt-6 md:mt-0"
                  style={{
                    backgroundColor: config?.branding?.accentColor ?? "#1658aa",
                  }}
                  onClick={handleRefresh}
                >
                  {errorHandlerTexts.button}
                  <ArrowPathIcon className="h-5 w-5" />
                </button>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
  


export default FaceCheckError;
